/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/action-panel/action-panel.component.scss */
div {
  color: #000000;
  background: #fff;
}
:host-context(.dark-theme) div {
  color: #FFFFFF;
  background: #252525;
}
.action-panel {
  height: initial;
  border-top: 1px solid #8d8d8d;
}
.dynamic-panel-height {
  height: calc(100% - 50px);
  border: none;
}
.action-header {
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
}
:host-context(.dark-theme) .action-header {
  border-bottom: solid 1px #5B5B5B;
}
::ng-deep [action-body] {
  height: 100%;
}
::ng-deep [action-body] > div {
  height: calc(100% - 100px);
  overflow: auto;
}
:host-context(.dark-theme) .action-panel {
  border: none;
}
/*# sourceMappingURL=action-panel.component.css.map */
